import { apiFetch } from './client';

export type ModerationStatus = 'pending' | 'approved' | 'rejected';

export interface ForumMessageRow {
  id: string;
  reseller_id: string;
  customer_id: string;
  ivr_node_id: string | null;
  caller_id: string | null;
  recording_id: string | null;
  status: ModerationStatus;
  moderated_by: string | null;
  moderated_at: string | null;
  listen_count: number;
  posted_from_e164: string | null;
  created_at: string;
  updated_at: string;
  recording_bucket: string | null;
  recording_key: string | null;
  recording_mime_type: string | null;
  recording_duration_ms: number | null;
  caller_display_name: string | null;
  ivr_node_ref: number | null;
  ivr_node_name: string | null;
}

export interface ForumStats {
  pending: number;
  approved: number;
  rejected: number;
}

export const forum = {
  list: (p: { status?: ModerationStatus; limit?: number; customer_id?: string; node_id?: string } = {}) => {
    const q = new URLSearchParams();
    if (p.status) q.set('status', p.status);
    if (p.limit) q.set('limit', String(p.limit));
    if (p.customer_id) q.set('customer_id', p.customer_id);
    if (p.node_id) q.set('node_id', p.node_id);
    return apiFetch<{ rows: ForumMessageRow[] }>(`/api/forum-messages?${q}`);
  },
  stats: (p: { node_id?: string } = {}) => {
    const q = new URLSearchParams();
    if (p.node_id) q.set('node_id', p.node_id);
    const qs = q.toString();
    return apiFetch<ForumStats>(`/api/forum-messages/stats${qs ? `?${qs}` : ''}`);
  },
  playback: (id: string) =>
    apiFetch<{ url: string; mime_type: string | null }>(`/api/forum-messages/${id}/playback`),
  /**
   * Approve or reject a forum message. On approve, an optional
   * `folder_id` re-points the underlying recording to that folder so
   * it surfaces from any bulletin/folder-variant node that uses the
   * folder. Frontend reads the folder off the post-mode node config
   * — see ForumPage for the wiring.
   */
  moderate: (
    id: string,
    status: 'approved' | 'rejected',
    folderId?: string | null,
  ) =>
    apiFetch<ForumMessageRow>(`/api/forum-messages/${id}/moderate`, {
      method: 'POST',
      body: JSON.stringify(
        status === 'approved' && folderId !== undefined
          ? { status, folder_id: folderId }
          : { status },
      ),
    }),
  remove: (id: string) =>
    apiFetch<void>(`/api/forum-messages/${id}`, { method: 'DELETE' }),
};
